import {Injectable} from '@angular/core';


@Injectable()
export class FinishListService {

    public doubleOut: any = [


        //0-9
        null,
        null,
        ['d1'],
        ['1','d1'],
        ['d2'],
        ['1','d2'],
        ['d3'],
        ['3','d2'],
        ['d4'],
        ['1','d4'],

        //10-19
        ['d5'],
        ['3','d4'],
        ['d6'],
        ['5','d4'],
        ['d7'],
        ['7','d4'],
        ['d8'],
        ['1','d8'],
        ['d9'],
        ['3','d8'],

        //20-29
        ['d10'],
        ['5','d8'],
        ['d11'],
        ['7','d8'],
        ['d12'],
        ['9','d8'],
        ['d13'],
        ['11','d8'],
        ['d14'],
        ['13','d8'],

        //30-39
        ['d15'],
        ['15','d8'],
        ['d16'],
        ['1','d16'],
        ['d17'],
        ['3','d16'],
        ['d18'],
        ['5','d16'],
        ['d19'],
        ['7','d16'],

        //40-49
        ['d20'],
        ['9','d16'],
        ['10','d16'],
        ['11','d16'],
        ['12','d16'],
        ['13','d16'],
        ['14','d16'],
        ['15','d16'],
        ['16','d16'],
        ['17','d16'],

        //50-59
        ['18','d16'],
        ['11','d20'],
        ['12','d20'],
        ['13','d20'],
        ['14','d20'],
        ['15','d20'],
        ['16','d20'],
        ['17','d20'],
        ['18','d20'],
        ['19','d20'],






        ['S20','D20'],
        ['25','D18'],
        ['T10','D16'],
        ['T13','D12'],
        ['T16','D8'],
        ['25','D20'],
        ['T10','D18'],
        ['T17','D8'],
        ['T20','D4'],
        ['T13','D15'],
        ['T10','D20'],
        ['T17','D10'],
        ['T12','D18'],
        ['T19','D8'],
        ['T18','D10'],
        ['T17','D12'],
        ['T20','D8'],
        ['T19','D10'],
        ['T18','D12'],
        ['T13','D20'],
        ['T20','D10'],
        ['T15','D18'],
        ['T14','D20'],
        ['T17','D16'],
        ['T20','D12'],
        ['T15','D20'],
        ['T18','D16'],
        ['T17','D18'],
        ['T16','D20'],
        ['T19','D16'],
        ['T18','D18'],
        ['T17','D20'],
        ['T20','D16'],
        ['T19','D18'],
        ['T18','D20'],
        ['T19','D19'],
        ['T20','D18'],
        ['T19','D20'],
        ['T20','D19'],
        ['T20','S7','D16'],
        ['T20','D20'],
        ['T17','Bull'],
        ['T20','510','D16'],
        ['T20','S3','D20'],
        ['T18','Bull'],
        ['T20','S13','D16'],
        ['T20','510','D18'],
        ['T19','Bull'],
        ['T20','S16','D16'],
        ['T20','S17','D16'],
        ['T20','S18','D16'],
        ['T20','S19','D16'],
        ['T20','S20','D16'],
        ['T20','S13','D20'],
        ['T20','S14','D20'],
        ['T20','S15','D20'],
        ['T20','S16','D20'],
        ['T20','S17','D20'],
        ['T20','S18','D20'],
        ['T20','S19','D20'],
        ['T20','S20','D20'],
        ['T20','T7','D20'],
        ['T18','T12','D16'],
        ['T19','T10','D18'],
        ['T20','S14','Bull'],
        ['25','T20','D20'],
        ['T19','S19','Bull'],
        ['T20','T17','D8'],
        ['T18','T14','D16'],
        ['T19','T12','D18'],
        ['T20','S20','Bull'],
        ['T20','T17','D10'],
        ['T20','T12','D18'],
        ['T20','T11','D20'],
        ['T20','T14','D16'],
        ['T17','T20','D12'],
        ['T20','T20','D8'],
        ['T19','T20','D10'],
        ['T20','T18','D12'],
        ['T19','T14','D20'],
        ['T20','T20','D10'],
        ['T17','T18','D18'],
        ['T20','T14','D20'],
        ['T20','T17','D16'],
        ['T18','T18','D18'],
        ['T20','T15','D20'],
        ['T20','T18','D16'],
        ['T19','T18','D18'],
        ['T20','T16','D20'],
        ['T20','T19','D16'],
        ['T20','T18','D18'],
        ['T20','T17','D20'],
        ['T20','T20','D16'],
        ['T20','T19','D18'],
        ['T20','T18','D20'],
        ['T20','T19','D19'],
        ['T20','T20','D18'],
        ['T20','T19','D20'],
        ['T20','T20','D19'],
        ['kein','Finish'],
        ['T20','T20','D20'],
        ['T20','T17','Bull'],
        ['kein','Finish'],
        ['kein','Finish'],
        ['T20','T18','Bull'],
        ['kein','Finish'],
        ['kein','Finish'],
        ['T20','T19','Bull'],
        ['kein','Finish'],
        ['kein','Finish'],
        ['T20 T20 Bull']

        
        
        
        
        
        




    ];

    constructor() {
    }



}



// WEBPACK FOOTER //
// ./src/app/providers/finishList.service.ts